import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Head } from '@/components/ui/Typography/Heading/Head';
export const ArticleHead = (props) => {
    const { children, className = '', tagName: Tag = 'div' } = props;
    return (_jsx(Tag, Object.assign({ className: clsx('w-full', 'bg-blue-gray-75', 'py-16 md:py-20 px-20 md:px-28', 'border-solid border-0 border-l-4 border-navy-300', className) }, { children: _jsx(Head, Object.assign({ className: clsx('md:text-head-xl', 'break-words'), color: 'base', size: 'lg' }, { children: children })) })));
};
